import api from "./api";

// Catálogo de localizações de ativos (alimenta o seletor de Localização).
export const getAssetLocations = () =>
  api.get("/assets/locations").then((r) => (Array.isArray(r.data) ? r.data : []));

export const createAssetLocation = (name) =>
  api.post("/assets/locations", { name }).then((r) => r.data);

export const deleteAssetLocation = (id) =>
  api.delete(`/assets/locations/${id}`).then((r) => r.data);
